/**
 * ClinicsEmptyState — CSS-shape illustration (no icon) + per-segment copy.
 */

const COPY = {
  all: { title: "לא נמצאו קליניקות", sub: "נסה לשנות את החיפוש או הסינון" },
  new: { title: "אין הרשמות חדשות ב-14 הימים האחרונים", sub: "כשקליניקה תירשם היא תופיע כאן" },
  trial: { title: "אין קליניקות בניסיון", sub: "כל הקליניקות במסלול בתשלום" },
  paying: { title: "אין קליניקות משלמות בסינון הזה", sub: "נסה להסיר סינון תגיות או מסלול" },
  risk: { title: "אין קליניקות בסיכון", sub: "כל הקליניקות פעילות ובריאות" },
  left: { title: "אין קליניקות שעזבו", sub: "" },
  inactive: { title: "אין קליניקות לא פעילות", sub: "" },
};

function ClinicsEmptyState({ segment = "all", filtered = false }) {
  const copy = filtered ? COPY.all : COPY[segment] || COPY.all;
  return (
    <div className="nivck2-empty" role="status">
      <div className="nivck2-empty-art" aria-hidden="true">
        <span className="nivck2-empty-card nivck2-empty-card-1">
          <i />
          <i />
        </span>
        <span className="nivck2-empty-card nivck2-empty-card-2">
          <i />
          <i />
        </span>
        <span className="nivck2-empty-card nivck2-empty-card-3">
          <i />
          <i />
        </span>
      </div>
      <p className="nivck2-empty-title">{copy.title}</p>
      {copy.sub && <span className="nivck2-empty-sub">{copy.sub}</span>}
    </div>
  );
}

export default ClinicsEmptyState;
